import React, { useEffect, useState } from "react";
import { live_courses } from "../../../Mock/Home";
import Card from "./Card";
import axios from "axios";
import Loading from "../../../utils/Loader/Loading";

const LiveCourseContainer = ({id}) => {

   let [state, setState] = useState([]);
    let [isLoading, setIsLoading] = useState(true);
    let [isError, setIsError] = useState(false);
  
    useEffect(() => {
      let fetchCards = async () => {
        try {
          let response = await axios.get(
            `https://vercel-deployment-w4ja.onrender.com/api/get_all_cards`
          );
          setState(response.data);
        } catch (error) {
          console.log(error);
          setIsError(true);
        } finally {
          setIsLoading(false);
        }
      };
      fetchCards();
    }, []);

  return (
    <>
      {isLoading && <Loading />}
      {!isLoading && !isError && state.length !== 0 && (
        <div className="max-w-7xl m-auto mt-16 max-sm:px-5">
          <h1 className="text-[#2C3E50] text-2xl font-semibold mb-10">
            {" "}
            Live Courses
          </h1>
          <div className="grid grid-cols-3 gap-6 max-sm:grid-cols-1">
            {state.map((value, index) => {
              return <Card {...value} key={index} />;
            })}
          </div>
        </div>
      )}
      {isError && "Error Occurred"}
    </>
  );
};

export default LiveCourseContainer;
